<script>
import Vue from "vue";
import ResizeObserver from "resize-observer-polyfill";
import defer from "lodash/defer";

export default {
  data() {
    return {
      width: 0,
      height: 0,
    };
  },
  props: {
    styles: {
      type: String,
      default: "",
    },
    bodyClass: {
      type: String,
      default: "",
    },
  },

  render(h) {
    return h("iframe", {
      on: { load: this.renderChildren },
      style: {
        width: this.width + "px",
        height: this.height + "px",
        border: "none",
      },
    });
  },

  beforeUpdate() {
    //freezing to prevent unnessessary Reactifiation of vNodes
    if (this.iframeApp) {
      this.iframeApp.children = Object.freeze(this.$slots.default);
    }
  },

  mounted() {
    this.$emit("mounted");
    this.height = 0;
    this.width = 0;
    this.resizer();
    jQuery(this.$el.contentWindow).on("scroll load", this.resizer);
    jQuery(this.$el.contentDocument)
      .find("img")
      .on("load", () => {
        this.resizer();
      });
  },

  destroyed() {
    this.iframeApp && this.iframeApp.$destroy();
    this.$emit("destroyed");
  },

  methods: {
    // add styles and render children slots
    renderChildren() {
      this.addStyles();
      const children = this.$slots.default;
      const body = this.$el.contentDocument.body;
      body.className = this.bodyClass;
      body.style.background = "transparent";

      const el = document.createElement("DIV"); // we will mount or nested app to this element
      body.appendChild(el);

      // make sure links open in parent
      let base = document.createElement("base");
      base.target = "_top";
      this.$el.contentDocument
        .getElementsByTagName("head")[0]
        .appendChild(base);

      Vue.prototype.$frameDoc = this.$el.contentDocument;
      const iframeApp = new Vue({
        name: "iframeApp",
        store: this.$store,
        //freezing to prevent unnessessary Reactifiation of vNodes
        data: { children: Object.freeze(children) },
        render(h) {
          return h("div", this.children);
        },
      });
      iframeApp.$mount(el); // mount into iframe
      this.iframeApp = iframeApp; // cache instance for later updates

      // return;
      // size frame
      const ro = new ResizeObserver(this.resizer);
      const mo = new MutationObserver(this.resizer);
      ro.observe(body);
      mo.observe(body, {
        attributes: true,
        childList: true,
        subtree: true,
      });

      if (this.$event) {
        this.$event.$on("heartbeat", this.resizer);
      }

      // prevent FF drag/drop issues
      body.ondrop = function (event) {
        event.preventDefault();
        event.stopPropagation();
      };
    },

    /**
     * Append styles to iframe head
     */
    addStyles() {
      if (!this.styles) {
        return;
      }

      this.addRule(this.styles);
    },

    addRule(rule) {
      let css = this.$el.contentDocument.createElement("style");
      css.type = "text/css";
      if (css.styleSheet) {
        css.styleSheet.cssText = rule; // Support for IE
      } else {
        css.appendChild(this.$el.contentDocument.createTextNode(rule)); // Support for the rest
      }
      this.$el.contentDocument.getElementsByTagName("head")[0].appendChild(css);
    },

    resizer(mutationsList, observer) {
      this.width = 0;
      this.height = 0;
      this.$nextTick(() => {
        this.resize();
        defer(this.resize);
      });
    },

    resize() {
      if (this?.$el?.contentDocument?.body) {
        this.width = this.$el.contentDocument.body.scrollWidth;
        this.height = this.$el.contentDocument.body.scrollHeight;
        this.$emit("resized", {
          width: this.width,
          height: this.height,
        });
      }
    },
  },
};
</script>

<frame-styles styles="test.css" />